export default "__VITE_PUBLIC_ASSET__ed0b6933__"